import { useEffect, useState, RefObject } from 'react'

type DropdownPosition = 'top' | 'bottom'

interface UseDropdownPositionProps {
  isOpen: boolean
  triggerRef: RefObject<HTMLElement>
  dropdownHeight?: number
}

export function useDropdownPosition({
  isOpen,
  triggerRef,
  dropdownHeight = 192, // max-h-48 = 12rem = 192px
}: UseDropdownPositionProps): DropdownPosition {
  const [position, setPosition] = useState<DropdownPosition>('bottom')

  useEffect(() => {
    if (!isOpen || !triggerRef.current) return

    const calculatePosition = () => {
      const triggerRect = triggerRef.current?.getBoundingClientRect()
      if (!triggerRect) return

      const spaceBelow = window.innerHeight - triggerRect.bottom
      const spaceAbove = triggerRect.top

      // If not enough space below but more space above, show on top
      if (spaceBelow < dropdownHeight && spaceAbove > spaceBelow) {
        setPosition('top')
      } else {
        setPosition('bottom')
      }
    }

    calculatePosition()
    window.addEventListener('resize', calculatePosition)
    window.addEventListener('scroll', calculatePosition, true)

    return () => {
      window.removeEventListener('resize', calculatePosition)
      window.removeEventListener('scroll', calculatePosition, true)
    }
  }, [isOpen, triggerRef, dropdownHeight])

  return position
}

